var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"health-check-survey-intro",attrs:{"id":"survey_intro"},on:{"click":_vm.start}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.hcData.instructions)}})])}
var staticRenderFns = []

export { render, staticRenderFns }